module.exports = __webpack_public_path__ + "img/Jump Casting89.93515936.jpg";